import _ from 'lodash';
import { hideLoader, showLoader } from "../../loader/loader";
import { showErrorAction } from "../../error/errorActionCreator";
import interpolateString from '../../../utility/stringInterpolation';
import { getDimensionMembersData, getDimensionsForPolicy, getHierarchyForDimension, getAttributes } from '../../../services/policy';
import { setDimensions, setDimensionPolicyData, setPaginatedDimensionMembers, setDimensionsPageData, setDimensionsMembersData, setDimensionAttributes } from '../policyDimension/dimensionActionCreator';
import {
  GET_DIMENSIONS_ERROR,
  POLICY_HIERARCHY,
  POLICY_HIERARCHY_ALL,
  DIMENSION_LEVEL_LIMIT,
  GET_DIMENSIONS_ATTRIBUTES_ERROR
} from '../../../shared/PolicyDialog/constants';

export const getDimensions = async (dispatch: Function) => {
  let errorMessage = { message: '' };
  let dimensions: any = []
  dispatch(showLoader);

  try {
    const response = await getDimensionsForPolicy();
    dimensions = response.entities;
  } catch (error: any) {
    errorMessage = {
      message: interpolateString([error], GET_DIMENSIONS_ERROR)
    };
  } finally {
    if (dimensions.length > 0) {
      dimensions = dimensions.map((dimension: any) => ({
        displayName: dimension.label,
        key: dimension.id,
        ...dimension
      }));
    }
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoader);
    dispatch(setDimensions(dimensions));
  }
};

export const getDimensionAttributes = async (dispatch: Function, dimensionId: string) => {
  let errorMessage = { message: '' };
  let attributes: any = [];
  const type = 'DIMENSION';
  dispatch(showLoader);

  try {
    const response = await getAttributes(dimensionId, type);
    attributes = response.attributes.map((attribute: any) => ({
      displayName: attribute.label,
      key: attribute.id
    }));
  } catch (error: any) {
    if (error.response.status !== 404) {
      errorMessage = {
        message: interpolateString([`${error?.response?.data?.statusCode} ${error?.response?.data?.message}`], GET_DIMENSIONS_ATTRIBUTES_ERROR)
      };
    }
  } finally {
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoader);
    dispatch(setDimensionAttributes(attributes));
  }
};

export const getHierarchy = async (dispatch: Function, dimensionId: string) => {
  let errorMessage = { message: '', info: '' };
  let hierarchy;
  dispatch(showLoader);

  try {
    const response = await getHierarchyForDimension(dimensionId);
    const [authorizingHierarchies, nonAuthorizingHierarchies] = _.partition(
      response.entities,
      hierarchy => hierarchy.useForAuthorization
    );
    hierarchy = authorizingHierarchies[0];
    dispatch(
      setDimensionPolicyData(POLICY_HIERARCHY_ALL, [...authorizingHierarchies, ...nonAuthorizingHierarchies])
    );
  } catch (error: any) {
    if (error.response.status === 404) {
      errorMessage = {
        info: error.response.data.message,
        message: ""
      };
    } else {
      errorMessage = {
        info: "",
        message: interpolateString([error.response.data.message], GET_DIMENSIONS_ERROR)
      };
    }
  } finally {
    if (hierarchy) {
      dispatch(setDimensionPolicyData(POLICY_HIERARCHY, hierarchy));
    }
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoader);
  }
};

export const getPaginatedDimensionMembers = async (dispatch: Function, reqParams: { id: string, level: string, filter?: string }, offset: number) => {
  const { id, level, filter = '' } = reqParams;
  let errorMessage = { message: '' };
  let members = { [level]: [] };
  let pageData = {
    limit: DIMENSION_LEVEL_LIMIT,
    offset: 0,
    pageNumber: 1,
    totalCount: 100
  };
  dispatch(showLoader);
  try {
    let response = await getDimensionMembersData(id, level, filter, DIMENSION_LEVEL_LIMIT, offset);
    members[level] = response.entities.length > 0 ? response.entities[0][level].filter((level: string) => level !== null).map((level: string) => {
      return {
        memberLabel: level,
        value: level
      };
    }) : [];
    pageData = { ...response.meta.page, pageNumber: Math.floor(response.meta.page.offset / DIMENSION_LEVEL_LIMIT) };
  } catch (error: any) {
    errorMessage = {
      message: interpolateString([error?.response?.data?.message], GET_DIMENSIONS_ERROR)
    };
  } finally {
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoader);
    offset > 0 ? dispatch(setPaginatedDimensionMembers(members, level)) : dispatch(setDimensionsMembersData(members));
    dispatch(setDimensionsPageData(pageData, level));
  }
};